export default "__VITE_ASSET__BarNRcPG__"